'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireAnalyticsOperationalEvent = exports.fireAnalyticsOperationalEventWithClient = exports.fireAnalyticsOperationEventWithEvent = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _events = require('./events');

var _mapDataPayloadToContextPayload = require('./map-data-payload-to-context-payload');

var _mapDataPayloadToContextPayload2 = _interopRequireDefault(_mapDataPayloadToContextPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNotUndefined = function isNotUndefined(a) {
    return !(0, _isUndefined2.default)(a);
};

var mapOperationalPayload = function mapOperationalPayload(payload) {
    var context = (0, _mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;

    return (0, _pickBy2.default)((0, _extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), isNotUndefined);
};

var mapOperationalPayloadToClient = function mapOperationalPayloadToClient(payload) {
    var context = (0, _mapDataPayloadToContextPayload2.default)(payload);
    var sourceName = payload.sourceName,
        sourceType = payload.sourceType,
        action = payload.action,
        actionSubject = payload.actionSubject,
        actionSubjectId = payload.actionSubjectId;

    if (!action || !actionSubject || !sourceName || !sourceType) {
        return false;
    }
    var source = sourceName + sourceType;

    return (0, _pickBy2.default)((0, _extends3.default)({}, context, {
        source: source,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), isNotUndefined);
};

var fireAnalyticsOperationEventWithEvent = exports.fireAnalyticsOperationEventWithEvent = function fireAnalyticsOperationEventWithEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, _extends3.default)({}, mapOperationalPayload(payload), { analyticsType: _events.OPERATIONAL_EVENT_TYPE })).fire();
};

var fireAnalyticsOperationalEventWithClient = exports.fireAnalyticsOperationalEventWithClient = function fireAnalyticsOperationalEventWithClient(client, payload) {
    if (!client.sendOperationalEvent) {
        throw new Error('No Operational event fired, sendOperationEvent doesnt exist');
    }
    if (!(typeof client.sendOperationalEvent === 'function')) {
        throw new Error('No Operational event fired, sendOperationEvent is not a function');
    }

    var mappedPayload = mapOperationalPayloadToClient(payload);

    if (!mappedPayload) {
        throw new Error('No Operational event fired, missing payload attributes. Operational events require an action, actionSubject, sourceName and sourceType');
    }

    return client.sendOperationalEvent(mappedPayload);
};

var fireAnalyticsOperationalEvent = exports.fireAnalyticsOperationalEvent = function fireAnalyticsOperationalEvent(data) {
    if (data.client) {
        return fireAnalyticsOperationalEventWithClient(data.client, data.payload);
    }
    return fireAnalyticsOperationEventWithEvent(data.analyticsEvent, data.payload);
};